import(/* webpackMode: "eager" */ "/codebuild/output/src1967388129/src/actions-runner/_work/eon-service/eon-service/frontend/apps/eon/src/app/error.tsx");
